import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Text, VStack } from "native-base";
import React from "react";
import { useForm } from "react-hook-form";

import FormButton from "@/components/atoms/FormButton";
import TextInput from "@/components/atoms/TextInput";
import FormField from "@/components/molecules/FormField";

import { EmailFormData, emailFormSchema } from "../schema";
import { RecoveryPassFormComponentProps } from "../types";

const EmailForm = ({
  isSubmiting,
  apiError,
  onSubmit,
  onCancel,
  onHaveCodePress,
}: RecoveryPassFormComponentProps<EmailFormData> & { onHaveCodePress: () => void }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailFormData>({
    resolver: yupResolver(emailFormSchema),
  });
  return (
    <VStack>
      <Text fontSize="lg" pb="12">
        Enviaremos o código de recuperação de senha para o seu e-mail
      </Text>
      <FormField
        control={control}
        name="email"
        label="Informe seu e-mail de cadastro"
        required
        error={errors.email || apiError}
        render={(value, onChange) => (
          <TextInput value={value} onChangeText={onChange} placeholder="E-mail" />
        )}
      />
      <FormButton isLoading={isSubmiting} mt="10" onPress={handleSubmit(onSubmit)}>
        Continuar
      </FormButton>
      <FormButton
        colorScheme="white"
        textColor="primary.700"
        my="4"
        shadow="2"
        onPress={() => onHaveCodePress()}>
        Já tenho um código
      </FormButton>
      <Button variant="ghost" onPress={() => onCancel()}>
        Cancelar
      </Button>
    </VStack>
  );
};

export default EmailForm;
